export const reviews = [
  {
    id: 1,
    userName: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20man%20with%20glasses%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20studio%20portrait%20lighting%2C%20minimalist%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '资深读者',
    content: '哈哈漫画网的阅读体验真的太棒了！下拉式阅读非常流畅，画质清晰，而且更新速度很快。我最喜欢《剑域王》，画风和剧情都是顶级水平。',
    rating: 5,
  },
  {
    id: 2,
    userName: '小橘子',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20woman%20with%20long%20hair%2C%20warm%20smile%2C%20clean%20white%20background%2C%20studio%20portrait%20lighting%2C%20minimalist&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '恋爱漫画爱好者',
    content: '《读者与女主》是我今年看过最好看的韩漫！剧情反转不断，画风细腻唯美。感谢哈哈漫画网提供这么优质的免费阅读平台。',
    rating: 5,
  },
  {
    id: 3,
    userName: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20casual%20style%2C%20confident%20expression%2C%20clean%20white%20background%2C%20studio%20portrait%20lighting&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '漫画评论人',
    content: '作为看了十年漫画的老读者，哈哈漫画网的韩漫资源真的非常全面。分类清晰，推荐算法也很准，总能发现好作品。',
    rating: 5,
  },
  {
    id: 4,
    userName: '追漫少女',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20woman%20with%20bright%20eyes%2C%20genuine%20smile%2C%20clean%20white%20background%2C%20studio%20portrait%20lighting%2C%20minimalist&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '日更追漫党',
    content: '每天必刷哈哈漫画网，更新提醒特别及时。下拉式阅读真的太方便了，一口气能看完一整部漫画，根本停不下来！',
    rating: 4,
  },
  {
    id: 5,
    userName: '动漫达人Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20stylish%20haircut%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20studio%20portrait%20lighting&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '动漫博主',
    content: '《龙族觉醒》的画风太震撼了，每一话都像在看电影大片。哈哈漫画网的服务器速度也很快，加载几乎零延迟。推荐给所有韩漫爱好者！',
    rating: 5,
  },
];